<template>
  <div class="dashboard">
    <loading v-if="loading" />
    <div class="page-content" v-else>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
    <header-menu></header-menu>
    <navigation></navigation>
  </div>
</template>
<script>
import navigation from "@/components/nav.vue";
import headerMenu from "@/components/header-menu.vue";
import { mapState } from "vuex";
export default {
  components: { navigation, headerMenu },
  computed: {
    ...mapState("app", ["loading"]),
    ...mapState("user", ["data"])
  }
};
</script>
